import React from "react";
import "../programs.css";
import ProgramMasterclassCard from "./ProgramMasterclassCard";

const ProgramMasterclassList = ({ masterClasses, title = "Masterclasses", isPreview = true }) => {

    return (
        <>
            <h2>Master Courses</h2>
            <div className="row">
                {masterClasses?.map((masterClass) => {
                    return (
                        <React.Fragment key={masterClass.id}>
                            <ProgramMasterclassCard
                                masterClass={masterClass}
                                isPreview={isPreview}
                            />
                        </React.Fragment>
                    );
                })}
            </div>
        </>
    );
};

export default ProgramMasterclassList;